<div class="incident-attachments-tab">
    <div style="display: flex; flex-direction: row; align-self: flex-end; margin-bottom: 16px">
        <cerrix-button
            #btnAttachment
            [dataUiid]="'incident-attachments-documents-button'"
            type="flat"
            color="primary-light"
            size="small"
            (click)="onAttachmentsClick()"
            >Documents {{ documentCount }}</cerrix-button
        >
        <cerrix-button
            #btnHyperlinks
            [dataUiid]="'incident-attachments-hyperlinks-button'"
            type="flat"
            color="accent"
            size="small"
            (click)="onHyperlinksClick()"
            >Hyperlinks {{ hyperlinkCount }}</cerrix-button
        >
    </div>
    @if (showDocuments) {
        <div #divDocuments [class.slide-in-ltr]="showDocuments">
            <div class="section-title">Documents</div>
            <cerrix-documents-list
                [canAdd]="canEditAttachments"
                [canEdit]="canEditAttachments"
                [canDelete]="canEditAttachments"
                [dataUiid]="'incident-documents-list'"
                [documents]="documents"
                (fileDownload)="onFileDownload($event)"
                (documentsChange)="onDocumentsChange($event)"
                (openDocumentViewer)="onOpenDocumentViewer($event)"
            ></cerrix-documents-list>
        </div>
    }
    @if (showHyperlinks) {
        <div #divHyperlinks [class.slide-in-rtl]="showHyperlinks">
            <span class="section-title">Hyperlinks</span>
            <cerrix-hyperlinks-list
                [canAdd]="canEditAttachments"
                [canEdit]="canEditAttachments"
                [canDelete]="canEditAttachments"
                [dataUiid]="'incident-hyperlinks-list'"
                [hyperlinks]="hyperlinks"
                (hyperlinksChange)="onHyperlinksChange($event)"
            ></cerrix-hyperlinks-list>
        </div>
    }
</div>
